import { render, staticRenderFns } from "./AdministratorApplicationList.vue?vue&type=template&id=43ee2964&scoped=true&"
var script = {}
import style0 from "./AdministratorApplicationList.vue?vue&type=style&index=0&id=43ee2964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ee2964",
  null
  
)

export default component.exports